import { createGlobalStyle, ThemeProps } from 'styled-components';
import { ThemeType } from '../theme/themeType';

const CssReset = createGlobalStyle`
  body {
    font-family: 'ManropeRegular', sans-serif;
    font-style: normal;
    background: ${(props: ThemeProps<ThemeType>) => props.theme.colors.background_dashboard};
    color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.text};

    &::-webkit-scrollbar {
      width: 12px;
    }

    &::-webkit-scrollbar-track {
      background: ${(props: ThemeProps<ThemeType>) => props.theme.colors.background_dashboard};
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.inactive};
      border-radius: 20px;
      border: 3px solid ${(props: ThemeProps<ThemeType>) => props.theme.colors.background_dashboard};
    }

    @media screen and (max-width: 900px) {
      min-width: 900px;
      overflow-x: scroll;
    }
  }

  /*
      Remove all the styles of the "User-Agent-Stylesheet", except for the 'display' property
      - The "symbol *" part is to solve Firefox SVG sprite bug
  */
  *:where(:not(iframe, canvas, img, svg, video, br, pre):not(svg *, symbol *)) {
    all: unset;
    display: revert;
  }

  pre {
    font: inherit;
    margin: 0;
    padding: 0;
  }

  /* Preferred box-sizing value */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
    line-height: 1;
  }

  /* Reapply the pointer cursor for anchor tags */
  a, button {
    cursor: revert;
  }

  /* Remove list styles (bullets/numbers) */
  ol, ul, menu {
    list-style: none;
  }

  /* For images to not be able to exceed their container */
  img {
    max-width: 100%;
  }

  /* removes spacing between cells in tables */
  table {
    border-collapse: collapse;
  }

  /* revert the 'white-space' property for textarea elements on Safari */
  textarea {
    white-space: revert;
  }

  /* minimum style to allow to style meter element */
  meter {
    -webkit-appearance: revert;
    appearance: revert;
  }

  /* reset default text opacity of input placeholder */
  ::placeholder {
    color: unset;
  }

  /* fix the feature of 'hidden' attribute.
  display:revert; revert to element instead of attribute */
  :where([hidden]) {
    display: none;
  }

  /* revert for bug in Chromium browsers
  - fix for the content editable attribute will work properly. */
  :where([contenteditable]) {
    -moz-user-modify: read-write;
    -webkit-user-modify: read-write;
    overflow-wrap: break-word;
    line-break: after-white-space;
    -webkit-line-break: after-white-space;
  }

  /* apply back the draggable feature - exist only in Chromium and Safari */
  :where([draggable="true"]) {
    -webkit-user-drag: element;
  }

  button {
    cursor: pointer;
  }


  a {
    color: inherit;
  }

  p {
    margin-bottom: 0;
  }

  h1, h2, h3, h4, h5, h6 {
    margin-bottom: 0;
  }

  pre, a, button, p, span, h1, h2, h3, h4, h5, h6 {
    overflow-wrap: anywhere;
    white-space: nowrap;
  }

  /* apply autofill styles in Chrome */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-text-fill-color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.text};
    background-color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.widget_hover_background} !important;
    -webkit-box-shadow: 0 0 0 1000px ${(props: ThemeProps<ThemeType>) => props.theme.colors.widget_hover_background} inset !important;
    transition: background-color 5000s ease-in-out 0s;
    width: 100%;
    margin-top: 0 !important;
    border: 1px solid ${(props: ThemeProps<ThemeType>) => props.theme.colors.widget_hover_background};
    border-radius: 12px;
    padding: 16px;
    position: relative;
  }
`;

export default CssReset;
